const convertItemQuantityToGrams = (item, servingAmount = "") => {
  let quantityInGrams;

  // Conversion factors
  const conversions = {
    grams: 1,
    ounces: 28.35,
    cups: 130,
    palms: 85,
    pounds: 453.6,
    mls: 1
  };

  // Check for exceptions
  const exceptions = {
    leafygreen: 25,
    potato: 250
  };

  // Determine the base conversion based on unit
  if (item.unit === "grams") {
    quantityInGrams = item.quantity; // No conversion needed
    if (item?.noOfQty) {
      let metricServingAmount = servingAmount
        ? servingAmount
        : item?.extraDetails
        ? item?.extraDetails?.serving?.metric_serving_amount
        : item?.details?.serving?.metric_serving_amount;
      let finalNoOfQty = item?.noOfQty;
      if (item?.extraDetails?.noOfQty) {
        finalNoOfQty = item?.noOfQty / item?.extraDetails?.noOfQty;
      }
      quantityInGrams =
        // item?.type === "customFood"
        //   ? item.quantity || metricServingAmount
        //   :
        (item.quantity || metricServingAmount || 1) * finalNoOfQty;
    }
  } else if (item.unit === "gmp") {
    quantityInGrams = item.quantity; // No conversion neede
  } else if (item.unit === "gmw") {
    quantityInGrams = item.quantity; // No conversion neede
  } else if (item.unit === "ounces") {
    quantityInGrams = item.quantity * conversions.ounces;
  } else if (item.unit === "cups") {
    // Check if item name has a specific exception
    const data =
      (item.name || item.entry800g)?.split(" ")?.join("").toLowerCase() ===
      "leafygreens"
        ? "leafygreen"
        : item.name;
    quantityInGrams = exceptions[data]
      ? item.quantity * exceptions[data]
      : item.quantity * conversions.cups;
  } else if (item.unit === "palms") {
    quantityInGrams = item.quantity * conversions.palms;
  } else if (item.unit === "pounds") {
    quantityInGrams = item.quantity * conversions.pounds;
  } else if (item.unit === "mls") {
    quantityInGrams = item.quantity * conversions.mls;
  } else {
    throw new Error(`Unknown unit: ${item.unit}`);
  }

  return { ...item, quantity: formatQuantity(+quantityInGrams), unit: "grams" };
};
function formatQuantity(quantityInGrams) {
  const decimalPart = quantityInGrams.toString().split(".")[1];

  if (!decimalPart) {
    return quantityInGrams; // Integer
  } else if (decimalPart.length === 1) {
    return quantityInGrams; // One decimal place
  } else {
    return Math.round(quantityInGrams * 100) / 100; // Round to 2 decimal places
  }
}
const getTotalWeight = (allItems) => {
  return allItems?.reduce(
    (prev, curr) => prev + convertItemQuantityToGrams(curr).quantity,
    0
  );
};
export { convertItemQuantityToGrams, getTotalWeight };
